import Swal,{SweetAlertIcon} from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal);
export function ShowSwalWithConfirmation(title: string, text: string, confirmButtonText: string = 'Yes, Proceed',CustomClass : string='', titleFontSize: string = '1.15rem') {
    return new Promise<boolean | string>((resolve, reject) => {
        MySwal.fire({
            // title: title,
            title: `<span style="font-size: ${titleFontSize}; font-weight: 600">${title}</span>`,
            text: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0052cb',
            cancelButtonColor: '#e1e3ea',
            confirmButtonText: confirmButtonText,
            cancelButtonText:  `<span style="color:black">Cancel</span>`,
            customClass: {
                container: CustomClass
            }
        }).then((result) => {
            if (result.isConfirmed) {
                resolve(true);
            } else {
                resolve(false);
            }
        })
    });
}

export function ShowSwalWithConfirmationMessage(title: string, text: string, confirmButtonText: string = 'Yes, Proceed') {
    return new Promise<boolean | string>((resolve, reject) => {
        MySwal.fire({
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: true,
            // confirmButtonColor: '#3085d6',
            // cancelButtonColor: '#d33',
            confirmButtonColor: '#0052cb',
            cancelButtonColor: '#e1e3ea',
            confirmButtonText: confirmButtonText,
            cancelButtonText:  `<span style="color:black">Cancel</span>`,
        }).then((result) => {
            if (result.isConfirmed) {
                resolve(true);
            } else {
                resolve(false);
            }
        })
    });
}

export function ShowSwal(title: string, text: string, icon: SweetAlertIcon  = 'success') {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
      showCancelButton: false,
      confirmButtonColor: '#0052cb',
      confirmButtonText: 'Okay'
    });
  }

  export function ShowSwalForCanvas(title: string, text: string, icon: SweetAlertIcon  = 'success') {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
      showCancelButton: false,
      confirmButtonColor: '#0052cb',
      confirmButtonText: 'Okay',
      customClass: {
        container: 'custom-swal-container' // Define a custom class
      }
    });
  }

  export function ShowSwalWithSuccessButton(title: string, text: string, confirmButtonText: string = 'OK') {
    return new Promise<boolean>((resolve) => {
        Swal.fire({
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#0052cb',
            confirmButtonText: confirmButtonText
        }).then((result) => {
            if (result.isConfirmed) {
                resolve(true);
            }
        });
    });
}


export function ShowSwalWithBillingDetail(
    title: string,
    html: string,
    confirmButtonText: string = 'Yes, Proceed',
    CustomClass: string = '',
    titleFontSize: string = '1.15rem'
) {
    return new Promise<boolean | string>((resolve, reject) => {
        MySwal.fire({
            title: `<span style="font-size: ${titleFontSize}; font-weight: 600">${title}</span>`,
            html: html,
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#0052cb',
            cancelButtonColor: '#e1e3ea',
            confirmButtonText: confirmButtonText,
            cancelButtonText: `<span style="color:black">Cancel</span>`,
            customClass: {
                container: CustomClass
            }
        }).then((result) => {
            if (result.isConfirmed) {
                resolve(true);
            } else {
                resolve(false);
            }
        });
    });
}

export function ShowSwalError(title: string, text: string = '', confirmButtonText: string = 'Ok', titleFontSize: string = '1.15rem') {
    return new Promise<boolean>((resolve) => {
        MySwal.fire({
            title: `<span style="font-size: ${titleFontSize}; font-weight: 600">${title}</span>`,
            text: text,
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#0052cb',
            confirmButtonText: confirmButtonText,
        }).then((result) => {
            resolve(result.isConfirmed === true);
        });
    });
}

export function confirmationLeaveInvoice() {
    return new Promise<boolean>((resolve) => {
        MySwal.fire({
            title: `<span style="font-weight: 700">You have unsaved changes</span>`,
            html: `<div>If you leave this page now, your changes will be lost.</div><div style="margin-top: 0.75rem">Would you like to stay and save your changes, or leave without saving?</div>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0052cb',
            cancelButtonColor: '#e1e3ea',
            confirmButtonText: 'Leave Without Saving',
            cancelButtonText: `<span style="color:black">Stay On Page</span>`,
            reverseButtons: true,
        }).then((result) => {
            resolve(result.isConfirmed === true);
        });
    });
}

export function ShowSwalInvoiceUpdateReminder(title: string, text: string = '', confirmButtonText: string = 'OK') {
    Swal.fire({
        title: title,
        text: text,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#0052cb',
        confirmButtonText: confirmButtonText,
        customClass: {
            container: 'custom-swal-container'
        }
    });
}